import React from "react";

import FooterNav from "./FooterNav";
import ContactForm from "./ContactForm";

const Footer = () => {
  return (
    <section className="section section-dark section-footer">
      <div className="container">
        <div className="footer-content">
          <h1>READY TO WORK WITH US?</h1>
          <ContactForm />
        </div>
      </div>
      <FooterNav />
    </section>
  );
};

export default Footer;
